// Local, private log of reset activity. Never leaves the device.
// Key: un_resets_v1 — [{ id, state, interventionId, completedAt, rated: 'helped'|'unsure'|null }]

const KEY = "un_resets_v1";

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};
const write = (v) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(v));
  } catch (e) {
    console.warn("[resetLog] write:", e?.message || e);
  }
};

const uid = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

export const getResetLog = () => read();

export const logResetCompletion = ({ state, interventionId }) => {
  const log = read();
  const entry = {
    id: uid(),
    state: state || null,
    interventionId,
    completedAt: new Date().toISOString(),
    rated: null,
  };
  log.unshift(entry);
  write(log);
  return entry;
};

export const rateReset = (id, rated) => {
  write(read().map((r) => (r.id === id ? { ...r, rated } : r)));
};

// ---------- Insights helpers (all local) ----------

export const getResetCount = () => read().length;

export const getWeekActivity = () => {
  // Last 7 days, oldest → newest: [{ day: 'Mon', count }]
  const log = read();
  const days = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const key = d.toDateString();
    days.push({
      day: d.toLocaleDateString(undefined, { weekday: "narrow" }),
      count: log.filter((r) => new Date(r.completedAt).toDateString() === key).length,
    });
  }
  return days;
};

export const getRecentWins = (n = 5) => read().slice(0, n);

export const getTopStates = (windowDays = 30) => {
  const cutoff = Date.now() - windowDays * 86400000;
  const counts = {};
  read()
    .filter((r) => r.state && new Date(r.completedAt).getTime() >= cutoff)
    .forEach((r) => {
      counts[r.state] = (counts[r.state] || 0) + 1;
    });
  return Object.entries(counts)
    .map(([state, count]) => ({ state, count }))
    .sort((a, b) => b.count - a.count);
};

export const getTopInterventions = (windowDays = 30) => {
  const cutoff = Date.now() - windowDays * 86400000;
  const counts = {};
  read()
    .filter((r) => new Date(r.completedAt).getTime() >= cutoff)
    .forEach((r) => {
      if (!counts[r.interventionId]) counts[r.interventionId] = { count: 0, helped: 0 };
      counts[r.interventionId].count += 1;
      if (r.rated === "helped") counts[r.interventionId].helped += 1;
    });
  return Object.entries(counts)
    .map(([interventionId, v]) => ({ interventionId, ...v }))
    .sort((a, b) => b.helped - a.helped || b.count - a.count);
};

export const getTimeOfDayPattern = (windowDays = 30) => {
  const cutoff = Date.now() - windowDays * 86400000;
  const buckets = { morning: 0, afternoon: 0, evening: 0, night: 0 };
  read()
    .filter((r) => new Date(r.completedAt).getTime() >= cutoff)
    .forEach((r) => {
      const h = new Date(r.completedAt).getHours();
      if (h >= 5 && h < 12) buckets.morning += 1;
      else if (h >= 12 && h < 17) buckets.afternoon += 1;
      else if (h >= 17 && h < 22) buckets.evening += 1;
      else buckets.night += 1;
    });
  return buckets;
};

export const RESET_LOG_KEY = KEY;
